import React, { useState, useEffect } from 'react'
import { commifyNumber } from '../../utils/utilities'
import { CheckboxGroup, Loading } from '../../components/shared'
import ConvertibleText from '../../components/shared/ConvertibleText'
import { Grid, Row, Col } from 'react-bootstrap'

export default function FeesSelector({
  isUnderwriter,
  manuallySetPricing,
  submission,
  pricingValues,
  onBlurHandler,
  defaultFeeOptions,
  isModified,
  updatePricingOptions,
  onChange,
}) {
  const coverageFees = submission.coverages?.gl?.fees || {}
  const coverageFeeSelectedKeys = Object.keys(coverageFees).filter(key => !!coverageFees[key].selected).sort()

  const [feeOptions, setFeeOptions] = useState(
    buildFeeOptionsData(defaultFeeOptions, coverageFees, pricingValues, isUnderwriter),
  )

  /**
   * Create new feeOptions Data for the CheckBoxGroup in case coverages.fees.selected
   * or Fees data in the pricingValues changes.
   */
  useEffect(() => {
    const newFeeOptions = buildFeeOptionsData(
      defaultFeeOptions,
      coverageFees,
      pricingValues,
      isUnderwriter
    )
    if (JSON.stringify(feeOptions) !== JSON.stringify(newFeeOptions)) {
      setFeeOptions(newFeeOptions)
    }
  }, [pricingValues?.inspectionFee, submission.coverages?.gl?.fees?.inspectionFee?.selected])

  const handleChangeOption = (evt, selectedValues) => {
    const feeOptionsCopy = feeOptions.map((option) => {
      return {
        ...option,
        selected: selectedValues.includes(option.value),
      }
    })
    setFeeOptions(feeOptionsCopy)
    updatePricingOptions(feeOptionsCopy)
    onChange(evt, selectedValues)
  }

  return (
    <div className="feesContainer feesContainerBorder">
      <h4 className="quoteTitle">Fees</h4>
      <Grid fluid={true} style={{ paddingLeft: '5px' }}>
        {feeOptions.map((option) => {
          return (
            <Row>
              <Col sm={8} xs={12}>
                <CheckboxGroup
                  value={coverageFeeSelectedKeys}
                  name={option.value}
                  options={feeOptions}
                  onChange={handleChangeOption}
                />
              </Col>
              {isModified ? (
                <Col smOffset={3} sm={1} xs={12}>
                  <Loading width="23px" height="23px" />
                </Col>
              ) : (
                <Col
                  sm={4}
                  xs={12}
                  style={{
                    paddingRight: 0,
                  }}
                >
                  <div
                    className="price-values"
                    style={{
                      textAlign: 'right',
                      marginTop: '10px',
                    }}
                  >
                    <ConvertibleText
                      manuallySetPricing={manuallySetPricing}
                      disabled={option.selected !== true}
                      value={{
                        name: option.key,
                        text: option.text,
                      }}
                      onBlurHandler={onBlurHandler}
                    />
                  </div>
                </Col>
              )}
            </Row>
          )
        })}
      </Grid>
    </div>
  )
}

/**
 * @description The CheckBoxGroup component expects data in a certain format.  This function builds that 
 * data.
 * 
 * @param {*} defaultFeeOptions 
 * @param {*} coverageFees 
 * @param {*} pricingValues 
 * @returns 
 */
const buildFeeOptionsData = (
  defaultFeeOptions,
  coverageFees = {},
  pricingValues,
  isUnderwriter
) => {
  return defaultFeeOptions.map((defaultFeeOption) => {
    let disableControl = false
    if (isUnderwriter === false && defaultFeeOption.key === 'inspectionFee') {
      disableControl = true;
    } 

    return {
      value: defaultFeeOption.value,
      key: defaultFeeOption.key,
      label: defaultFeeOption.label,
      selected:
        coverageFees[defaultFeeOption.key] &&
        coverageFees[defaultFeeOption.key].selected === true,
      text:
        typeof pricingValues[defaultFeeOption.key] === 'number'
          ? `$${commifyNumber(pricingValues[defaultFeeOption.key] || '0')}`
          : '$0',
      disable: disableControl
    }
  })
}
